import PAImage from "component/design-system/images/PAImage";
import Text from "component/design-system/typography/Text";
import { useTranslation } from "next-i18next";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./chat-return.module.scss";

function ChatReturn() {
  const { t } = useTranslation("static-pages");
  return (
    <div className={`${styles.chat_container} d-flex flex-wrap justify-content-between`}>
      <div className={`${styles.chat_container_left} d-flex flex-wrap  align-items-center`}>
        <PAImage
          src={getRelativeImagePath("/cms/pubicImages/images/pa-chat-v2.png")}
          width={100}
          height={46}
          alt="chatIcon"
          className="m-r-10"
        />
        <div className="d-flex flex-column">
          <Text size={4} lineHeight={1.5}>{t("contact_customer_care")}</Text>
          <Text size={4} lineHeight={1.5}>{t("raise_request")}</Text>
        </div>
      </div>
      <div className={`${styles.chat_container_right} d-flex flex-column`}>
        <Text size={4} bold>{t("Live Chat")}</Text>
        <Text size={4}>Mon - Sun: 6:00 am to 1:00 am ET</Text>
      </div>
    </div>
  );
}

export default ChatReturn;
